export const documentType = ["pdf", "word", "excel"];
export default documentType;
